import styles from "./Header.module.css";
import tempImage from "../../../../assets/tempIMG2.jpg";

export default function Header({ category }) {
  return (
    <main className={styles.main}>
      <div className={styles.title}>{category.post_title}</div>
      <div className={styles[`title-underline`]} />
      <div className={styles[`content-container`]}>
        <div className={styles.description}>{category.acf.description}</div>
        <img
          src={category.featured_media}
          alt="Head image."
          className={styles.image}
        />
      </div>
    </main>
  );
}
